import React from "react";
import Brand from "./Brand";
import UserHeader from "./UserHeader";

// En-tête des pages publiques (connexion, pages client, paiement...).
export default function PublicHeader({ hideLoginLink = false }) {
    return (
        <header id="header" className="lk-header lk-header--public">
            <div className="lk-header__top">
                <Brand href="https://lokapp.fr/" />
                <div className="lk-header__actions">
                    <a className="lk-header__textlink" href="https://lokapp.fr/" title="Retour sur lokapp.fr">
                        <i className="pi pi-globe" aria-hidden="true"></i>
                        <span>lokapp.fr</span>
                    </a>
                    <UserHeader hideLoginLink={hideLoginLink} />
                </div>
            </div>
        </header>
    );
}
